import { format } from 'date-fns';
import React, { useState } from 'react';
import DatePicker from 'react-date-picker';
import Calendar from '../svg/Calendar';
import IconButton from '../ActionIcons/IconButton';

interface IEditDateProps {
  value: Date | string;
  readonly?: boolean;
  onChange: (newDate: Date) => void;
}

export default function EditDate({
  value,
  readonly = false,
}: IEditDateProps) {
  const initialValue = typeof value === "string" ? new Date(value) : value;
  const [_value, setValue ] = useState<Date>(initialValue);

  const handleChange = (date: Date) => {
    if (!date) {
      return;
    }
    setValue(date)
  };

  if (readonly) {
    return <span>{format(_value, "dd. MMMM yyyy")}</span>;
  }

  return (
    <DatePicker
      value={_value}
      onChange={handleChange}
      calendarIcon={<Calendar size={18}/>}
      clearIcon={null}
    />
  );
}
